/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDUturnRightDownIcon16Light } from './ArrowDUturnRightDownIcon16Light';
import { ArrowDUturnRightDownIcon16Regular } from './ArrowDUturnRightDownIcon16Regular';
import { ArrowDUturnRightDownIcon16Solid } from './ArrowDUturnRightDownIcon16Solid';
import { ArrowDUturnRightDownIcon20Light } from './ArrowDUturnRightDownIcon20Light';
import { ArrowDUturnRightDownIcon20Regular } from './ArrowDUturnRightDownIcon20Regular';
import { ArrowDUturnRightDownIcon20Solid } from './ArrowDUturnRightDownIcon20Solid';
import { ArrowDUturnRightDownIcon24Regular } from './ArrowDUturnRightDownIcon24Regular';
import { ArrowDUturnRightDownIcon24Solid } from './ArrowDUturnRightDownIcon24Solid';
import { ArrowDUturnRightDownIcon32Regular } from './ArrowDUturnRightDownIcon32Regular';
import { ArrowDUturnRightDownIcon64Regular } from './ArrowDUturnRightDownIcon64Regular';
var sizes = {
    16: {
        light: ArrowDUturnRightDownIcon16Light,
        regular: ArrowDUturnRightDownIcon16Regular,
        solid: ArrowDUturnRightDownIcon16Solid,
    },
    20: {
        light: ArrowDUturnRightDownIcon20Light,
        regular: ArrowDUturnRightDownIcon20Regular,
        solid: ArrowDUturnRightDownIcon20Solid,
    },
    24: {
        regular: ArrowDUturnRightDownIcon24Regular,
        solid: ArrowDUturnRightDownIcon24Solid,
    },
    32: {
        regular: ArrowDUturnRightDownIcon32Regular,
    },
    64: {
        regular: ArrowDUturnRightDownIcon64Regular,
    },
};
export var ArrowDUturnRightDownIcon = forwardRef('ArrowDUturnRightDownIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
